<template>
    <div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>请购单号</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.no}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请机构</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.requireComName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>经办人</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.applicantName}}</span>
                </div>
            </div>

            <div class="form-group center" v-if="requireVoucher != null && requireVoucher.itemList != null">
                <div class="form-label">
                    <label>期望到货日期</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.itemList[0].desireArriveDate}}</span>
                </div>
            </div>

            <div class="form-row">
                <div class="form-label">
                    <label class="required">指定审核人</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-select placeholder="请选择" v-model="userId" :clearable=true>
                        <el-option v-for="item in retailerStaffList" :key="item.name" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </div>
            </div>

            <div class="form-group center">
                <div class="form-label">
                    <label>采购需求</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.desc}}</span>
                </div>
            </div>
        </div>
        <div class="table-layout">
            <el-table :data="getItemList" border style="width: 100%">
                <el-table-column prop="requireComName" label="公司名称" width="180"></el-table-column>
                <el-table-column prop="name" label="商品名称" width="180"></el-table-column>
                <el-table-column prop="goodsCatName" label="商品分类" width="180"></el-table-column>
                <el-table-column prop="goodsBrandName" label="商品品牌" width="180"></el-table-column>
                <el-table-column label="申请数量" width="95">
                    <template slot-scope="scope">
                        <el-input type="text" v-model.number="scope.row.quantity"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-tag style="background-color: transparent; border: none" close-transition>
                            <a class="swb-btn swb-btn-link" @click="removeGoods(scope.$index)">移除</a>
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import devcReqrApi from '../../api/devcReqr'
    import retailerApi from '../../api/retailer'

    export default {
//        name: 'swb-device-require-item-update',
        name: 'swb-require-goods-item-update',
        desc: '设备请购单项-修改',
        props: ['item'],
        data: function () {
            return {
                getItemList: [],
                itemList: null,
                id: null,
                applyTime: null,
                applyDesc: null,
                requireVoucher: {},
                retailerStaffList: [],
                userId: null,
            }
        },

        created: function () {
            this.getRequireGoodsItem();
            this.getStaffByComId();
        },
        methods: {
            validateQuantity: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入申请数量'));
                } else {
                    if(!Utils.isNumber(value) || value <= 0) {
                        callback(new Error('请输入大于0的数字'));
                    } else {
                        callback();
                    }
                }
            },
            getRequireGoodsItem: function (data) {
                let self = this;
                console.log(self.item);
                let postData = {};
                postData.id = self.item;
                devcReqrApi.getDeviceRequireVoucherInfo(postData, function (result) {
                    if(result.type === "info") {
                        self.requireVoucher = result.data;
                        self.getItemList = result.data.itemList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            removeGoods: function (index) {
                let self = this;
                let itemList = self.getItemList;
                for(var i = 0; i < itemList.length; i++) {
                    if(i == index) {
                        itemList.remove(itemList[i]);
                    }
                }
                self.getItemList = Utils.merge([], itemList);
            },

            getDlgResult: function () {
                let self = this;
                let result = {};
                let userId = self.userId;
                //
                let item = {};
                let itmes = self.getItemList;
                item.itmes = itmes;
                item.userId = userId;
                if(itmes != null && itmes.length > 0 && userId != null) {
                    result.type = 'info';
                    result.data = item;
                } else {
                    result.type = 'warn';
                    result.message = '至少剩余一个商品或请选择审核人！';
                }
                return result;
            },

            getStaffByComId: function () {
                let self = this;
                let postData = {};
                retailerApi.getRetailerStaffListByComId(postData, function (result) {
                    if(result.type === "info") {
                        self.retailerStaffList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/retailer/RequireGoodsItemUpdate.vue